// extracted by mini-css-extract-plugin
module.exports = {"showSolution":"showSolution__1HJWr","showIcon":"showIcon__1Vf2Z"};